module.exports = __webpack_public_path__ + "img/warning.f9bda3f2.svg";